// extracted by mini-css-extract-plugin
export default {"icon":"LQpzLGEG_2iywQ5IUPfB","hoverable":"WmjOrEYYLYaNksd3FYKg"};